import React, { useContext } from "react";
import OperationSideListView from "./OperationsSideListView";
import { Navigate } from "react-router-dom";
import PortalShell from "../Util/PortalShell";
import AuthContext from "../../store/auth-context";

const OperationsRootLayout = () => {
  const authCtx = useContext(AuthContext);
  if (!authCtx.user || !authCtx.user.is_admin) {
    return <Navigate to={"/login"} replace />;
  }

  // Skip link, "Main" navigation, one main region, page title (ticket 11): see PortalShell
  return <PortalShell navigation={<OperationSideListView />} />;
};

export default OperationsRootLayout;
